import React,{useState, useEffect} from 'react';
import { Box, DataChart,Text,Spinner } from 'grommet';
import { NavigationSnackBar } from '../../../components/utils/shared/shared';
import { APIRequest } from '../../../components/utils/shared/requests';

const data = [];
for (let i = 1; i < 8; i += 1) {
  const v = Math.sin(i / 2.0);
  data.push({
    percent: Math.abs(v * 100),
  });
}

const Load = (props) => {
    if (props.load){
        return <Box justify='center' align='center' margin={'small'}><Spinner /></Box>
    } else {
        return null;
    }
}
 
const AllReports = (props) => {
    const [shipmentCountData, setShipmentCountData] = useState([]);
    const [shipmentUserCountData, setShipmentUserCountData] = useState([]);
    const [shipmentRoutesCountData, setShipmentRoutesCountData] = useState([]);
    const [load, setLoad] = useState(true)
    useEffect(() => {     
      APIRequest('/dashboard/admin-report-summary').then(result => {setShipmentCountData(result.shipmentMonthCount); setShipmentUserCountData(result.shipmentUserCount); setShipmentRoutesCountData(result.shipmentRoutes) ;setLoad(false)})
    
     },[]);
    return (
        <Box background={'background-back'}>
            <NavigationSnackBar title={'All Reports'} user={props.user} pages={[{name: 'Dashboard', link: '/dashboard'}]}  />
            <Box align="center" justify="start" pad="medium">
                <Box elevation='large' round pad='small' margin='small' background={'background-front'}>
                <Text margin={{top:'small'}} weight={'bold'} justify='center' alignSelf='center' align='center'>Total Shipments by Month</Text>
               <DataChart  chart={[ { property: 'count', type: 'line', opacity: 'strong', thickness: 'xsmall' }, { property: 'count', type: 'point', point: 'circle', thickness: 'medium' } ]}placeholder={<Load load={load} />} legend size={{width: 'xxlarge'}} margin={'small'} data={shipmentCountData} detail series={[{property:'month', label:'Month', render:(value) => <Text>{value}</Text>},{property:'count', label:'Shipments'}]}  axis={{x: { property: 'month', granularity: 'medium' },y: { property: 'count', granularity: 'fine' } }}   />
               </Box>
               <Box elevation='large' round pad='small' margin='small' background={'background-front'}>
               <Text margin={{top:'small'}} weight={'bold'} justify='center' alignSelf='center' align='center'>Total Shipments by User</Text>
                <DataChart placeholder={<Load load={load} />} legend size={{width: 'xxlarge'}} data={shipmentUserCountData} detail margin='small' series={[{property:'user', label:'User'},{property:'count', label:'Shipments'}]}  axis={{y: { property: 'count', granularity: 'fine' },x: { property: 'user', granularity: 'fine' }  }}/>
                </Box>
                <Box elevation='large' round pad='small' margin='small' background={'background-front'}>
                    <Text margin={{top:'small'}} weight={'bold'} justify='center' alignSelf='center' align='center'>Most Shipped Routes</Text>
                    <DataChart placeholder={<Load load={load} />} legend size={{width: 'xxlarge'}} data={shipmentRoutesCountData} detail margin='small' series={[{label:'Route', property:'route'},{property:'count', label:'Shipments'}]}  axis={{y: { property: 'count', granularity: 'medium' }}}/>

                </Box>
            </Box>
        </Box>
    )

}

export default AllReports